import * as React from 'react';
import { SelectChangeEvent } from '@mui/material';

import { useAssessmentContext } from '../../context';
import IAssessmentElement from '../../models/IAssessmentElement';
import { IValidatorConfig, IValidatorResult } from '../../models/IValidator';
import useQuestionManager from '../../plugins/useQuestionManager';
import DropDown from '../inputs/DropDown';

interface IProps 
{
	question: IAssessmentElement,
	onValidatorResultChanged?(validatorResult: IValidatorResult): void,
	onResetValidation?(parentElement: IAssessmentElement | null): void,
	validatorConfig?: IValidatorConfig
}

export function DropdownInput(props: IProps)
{
	const assessmentContext = useAssessmentContext();
	const questionManager = useQuestionManager();
	const [answerValues, setAnswerValues] = React.useState<string[]>(assessmentContext.pageAnswers.filter(x => x.id == props.question.id)[0]?.value ?? []);

	// Sync with external updates from Redux (e.g., address lookup population)
	React.useEffect(() =>
	{
		const externalAnswers = assessmentContext.pageAnswers.filter(
			x => x.id == props.question.id
		)[0]?.value ?? [];

		setAnswerValues(externalAnswers);
	}, [assessmentContext.pageAnswers, props.question.id]);

	const onChange = (event: SelectChangeEvent<unknown>) =>
	{
		const value = event.target.value as string;
		setAnswerValues([value])
		questionManager.updateAnswerValue(props.question.id, [value]);

		if(props.onResetValidation && props.question.hasConditionalChildren)
			props.onResetValidation(props.question);
	};

	return <DropDown
		onValidatorResultChanged={props.onValidatorResultChanged}
		validator={{
			validatorRules: questionManager.getQuestionValidatorRules(props.question),
			config: props.validatorConfig
		}}
		value={answerValues[0] ?? ''}
		answerValue={answerValues}
		options={props.question.options ?? []}
		onChange={onChange}>
	</DropDown>
}

export default DropdownInput
